import { getBreakClass } from '../../../utils/Functions.utils';

type GeneralInformationProps = {
  data: {
    entityType: string;
    version: string;
    organizationName: string;
    complianceContactPerson: string;
    description: string;
    createdAt: string;
  };
};

export function GeneralInformation({ data }: GeneralInformationProps) {
  const formatDate = (dateString: string) => {
    const date = new Date(dateString);
    const day = date.getDate();
    const month = date.toLocaleString('en-US', { month: 'short' });
    const year = date.getFullYear();
    const hours = date.getHours().toString().padStart(2, '0');
    const minutes = date.getMinutes().toString().padStart(2, '0');
    return `${day} ${month} ${year}, ${hours}:${minutes}`;
  };

  return (
    <div className="flex flex-col gap-6 text-left">
      <h2 className="font-sans font-medium text-base leading-6 text-left text-gray-900v2">
        General Information
      </h2>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
        <div className="flex flex-col gap-2 text-left">
          <label className="font-sans font-medium text-xs leading-5 uppercase text-gray-550 text-left">
            Entity Type:
          </label>
          <span className="font-sans font-medium text-base leading-6 text-gray-900 text-left">
            {data.entityType.charAt(0).toUpperCase() + data.entityType.slice(1).toLowerCase()}
          </span>
        </div>

        <div className="flex flex-col gap-2 text-left">
          <label className="font-sans font-medium text-xs leading-5 uppercase text-gray-550 text-left">
            Version:
          </label>
          <span className={`font-sans font-medium text-base leading-6 text-gray-900 text-left ${getBreakClass(data.version)}`}>
            {data.version}
          </span>
        </div>

        <div className="flex flex-col gap-2 text-left">
          <label className="font-sans font-medium text-xs leading-5 uppercase text-gray-550 text-left">
            Organization Name:
          </label>
          <span className={`font-sans font-medium text-base leading-6 text-gray-900 text-left ${getBreakClass(data.organizationName)}`}>
            {data.organizationName}
          </span>
        </div>

        <div className="flex flex-col gap-2 text-left">
          <label className="font-sans font-medium text-xs leading-5 uppercase text-gray-550 text-left">
            Compliance Contact Person:
          </label>
          <span className={`font-sans font-medium text-base leading-6 text-gray-900 text-left ${getBreakClass(data.complianceContactPerson)}`}>
            {data.complianceContactPerson}
          </span>
        </div>
      </div>

      {data.description && <div className="flex flex-col gap-2 text-left">
        <label className="font-sans font-medium text-xs leading-5 uppercase text-gray-550 text-left">
          Description:
        </label>
        <span className={`font-sans font-normal text-base leading-6 text-gray-900 text-left  ${getBreakClass(data.description)}`}>
          {data.description}
        </span>
      </div>}

      <div className="flex flex-col gap-2 text-left">
        <label className="font-sans font-medium text-xs leading-5 uppercase text-gray-550 text-left">
          Created:
        </label>
        <span className="font-sans font-medium text-base leading-6 text-gray-900 text-left">
          {formatDate(data.createdAt)}
        </span>
      </div>
    </div>
  );
}
